import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedBack = _resolveComponent("SharedBack")!
  const _component_SharedUpload = _resolveComponent("SharedUpload")!
  const _component_SharedValidate = _resolveComponent("SharedValidate")!
  const _component_SharedDownload = _resolveComponent("SharedDownload")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedCard = _resolveComponent("SharedCard")!

  return (_openBlock(), _createBlock(_component_SharedCard, {
    class: _normalizeClass(_ctx.b())
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('header'))
      }, [
        _createVNode(_component_SharedBack, { onClick: _ctx.handleBack }, null, 8, ["onClick"]),
        _createElementVNode("h3", {
          class: _normalizeClass(_ctx.b('header-title'))
        }, _toDisplayString(_ctx.$t("Загрузка документов")), 3)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('passport-photo'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('passport'))
        }, [
          _createElementVNode("h5", {
            class: _normalizeClass(_ctx.b('title'))
          }, _toDisplayString(_ctx.$t("Загрузка паспорта*")), 3),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('passport-uploads'))
          }, [
            _createVNode(_component_SharedValidate, {
              field: "kyc-personal-documents-passport-selfie",
              value: _ctx.documents['kyc-personal-documents-passport-selfie'].id,
              "is-validate": _ctx.isValidate,
              "is-center": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SharedUpload, {
                  class: _normalizeClass(_ctx.b('upload')),
                  document: _ctx.documents['kyc-personal-documents-passport-selfie'],
                  "is-loading": _ctx.isLoading,
                  "is-readonly": _ctx.isReadonly,
                  "is-error": 
                _ctx.isValidate &&
                !_ctx.documents['kyc-personal-documents-passport-selfie'].id
              ,
                  onUpload: _ctx.handleUploadFile,
                  onRemove: _ctx.handleRemoveFile
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Страница")) + " ", 1),
                    _hoisted_1,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("с фото")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "document", "is-loading", "is-readonly", "is-error", "onUpload", "onRemove"])
              ]),
              _: 1
            }, 8, ["value", "is-validate"]),
            _createVNode(_component_SharedValidate, {
              field: "kyc-personal-documents-passport-address",
              value: _ctx.documents['kyc-personal-documents-passport-address'].id,
              "is-validate": _ctx.isValidate,
              "is-center": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SharedUpload, {
                  class: _normalizeClass(_ctx.b('upload')),
                  document: _ctx.documents['kyc-personal-documents-passport-address'],
                  "is-loading": _ctx.isLoading,
                  "is-readonly": _ctx.isReadonly,
                  "is-error": 
                _ctx.isValidate &&
                !_ctx.documents['kyc-personal-documents-passport-address'].id
              ,
                  onUpload: _ctx.handleUploadFile,
                  onRemove: _ctx.handleRemoveFile
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Страница")) + " ", 1),
                    _hoisted_2,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("с пропиской")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "document", "is-loading", "is-readonly", "is-error", "onUpload", "onRemove"])
              ]),
              _: 1
            }, 8, ["value", "is-validate"])
          ], 2)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('photo'))
        }, [
          _createElementVNode("h5", {
            class: _normalizeClass(_ctx.b('title'))
          }, _toDisplayString(_ctx.$t("Загрузка селфи*")), 3),
          _createVNode(_component_SharedValidate, {
            class: _normalizeClass(_ctx.b('photo-upload')),
            field: "kyc-personal-documents-selfie",
            value: _ctx.documents['kyc-personal-documents-selfie'].id,
            "is-validate": _ctx.isValidate,
            "is-center": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('photo-upload')),
                document: _ctx.documents['kyc-personal-documents-selfie'],
                "is-loading": _ctx.isLoading,
                "is-readonly": _ctx.isReadonly,
                isCenter: true,
                "is-label": false,
                "is-error": 
              _ctx.isValidate && !_ctx.documents['kyc-personal-documents-selfie'].id
            ,
                onUpload: _ctx.handleUploadFile,
                onRemove: _ctx.handleRemoveFile
              }, null, 8, ["class", "document", "is-loading", "is-readonly", "is-error", "onUpload", "onRemove"])
            ]),
            _: 1
          }, 8, ["class", "value", "is-validate"])
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('agreements'))
      }, [
        _createElementVNode("h5", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t("Скачайте и подпишите соглашения*")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('agreements-block'))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('agreements-group', { kyc: true }))
          }, [
            _createVNode(_component_SharedDownload, { document: _ctx.displayedQuestionnaireOfAnIndividual }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Анкета")) + " ", 1),
                _createElementVNode("br", {
                  class: _normalizeClass(_ctx.b('agreements-maintenance'))
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("физического лица")), 1)
              ]),
              _: 1
            }, 8, ["document"]),
            _createVNode(_component_SharedValidate, {
              field: "kyc-personal-documents-questionnaire",
              value: _ctx.documents['kyc-personal-documents-questionnaire'].id,
              "is-validate": _ctx.isValidate,
              "is-center": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SharedUpload, {
                  class: _normalizeClass(_ctx.b('upload')),
                  document: _ctx.documents['kyc-personal-documents-questionnaire'],
                  "is-loading": _ctx.isLoading,
                  "is-readonly": _ctx.isReadonly,
                  "is-error": 
                _ctx.isValidate &&
                !_ctx.documents['kyc-personal-documents-questionnaire'].id
              ,
                  onUpload: _ctx.handleUploadFile,
                  onRemove: _ctx.handleRemoveFile
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Подписанное")) + " ", 1),
                    _hoisted_3,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("соглашение")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "document", "is-loading", "is-readonly", "is-error", "onUpload", "onRemove"])
              ]),
              _: 1
            }, 8, ["value", "is-validate"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('agreements-group', { personal: true }))
          }, [
            _createVNode(_component_SharedDownload, { document: _ctx.displayedConsentToTheProcessingOfPersonalData }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Согласие на обработку")) + " ", 1),
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("персональных данных")), 1)
              ]),
              _: 1
            }, 8, ["document"]),
            _createVNode(_component_SharedValidate, {
              field: "kyc-personal-documents-personal-data",
              value: _ctx.documents['kyc-personal-documents-personal-data'].id,
              "is-validate": _ctx.isValidate,
              "is-center": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SharedUpload, {
                  class: _normalizeClass(_ctx.b('upload')),
                  document: _ctx.documents['kyc-personal-documents-personal-data'],
                  "is-loading": _ctx.isLoading,
                  "is-readonly": _ctx.isReadonly,
                  "is-error": 
                _ctx.isValidate &&
                !_ctx.documents['kyc-personal-documents-personal-data'].id
              ,
                  onUpload: _ctx.handleUploadFile,
                  onRemove: _ctx.handleRemoveFile
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Подписанное")) + " ", 1),
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("соглашение")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "document", "is-loading", "is-readonly", "is-error", "onUpload", "onRemove"])
              ]),
              _: 1
            }, 8, ["value", "is-validate"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('agreements-group'))
          }, [
            _createVNode(_component_SharedDownload, { document: _ctx.displayedBrokerageAgreement }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Брокерский")) + " ", 1),
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("договор")), 1)
              ]),
              _: 1
            }, 8, ["document"]),
            _createVNode(_component_SharedValidate, {
              field: "kyc-personal-documents-broker",
              value: _ctx.documents['kyc-personal-documents-broker'].id,
              "is-validate": _ctx.isValidate,
              "is-center": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SharedUpload, {
                  class: _normalizeClass(_ctx.b('upload')),
                  document: _ctx.documents['kyc-personal-documents-broker'],
                  "is-loading": _ctx.isLoading,
                  "is-readonly": _ctx.isReadonly,
                  "is-error": 
                _ctx.isValidate && !_ctx.documents['kyc-personal-documents-broker'].id
              ,
                  onUpload: _ctx.handleUploadFile,
                  onRemove: _ctx.handleRemoveFile
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Подписанное")) + " ", 1),
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("соглашение")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "document", "is-loading", "is-readonly", "is-error", "onUpload", "onRemove"])
              ]),
              _: 1
            }, 8, ["value", "is-validate"])
          ], 2)
        ], 2)
      ], 2),
      (_ctx.isOtherShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('other'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('other-title'))
            }, _toDisplayString(_ctx.$t(
            "Пожалуйста, прикрепите иные документы для подтверждения вашей верификации"
          )), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('other-label'))
            }, _toDisplayString(_ctx.$t(
            "Например: Документ о происхождении денежных средств, Документ подтверждающий постановку на учет в налоговом органе и другие"
          )), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('other-documents'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                return (_openBlock(), _createBlock(_component_SharedUpload, {
                  key: file.uuid,
                  class: _normalizeClass(_ctx.b('other-upload')),
                  document: file,
                  "is-upload": file.isUpload,
                  "is-remove": file.isRemove,
                  "is-readonly": _ctx.isReadonly,
                  "is-loading": _ctx.isLoading,
                  onRemove: _ctx.handleRemoveAdditionalFile
                }, _createSlots({ _: 2 }, [
                  (file.name)
                    ? {
                        name: "label",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(file.name), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["class", "document", "is-upload", "is-remove", "is-readonly", "is-loading", "onRemove"]))
              }), 128)),
              (_ctx.isAddtionalUpload)
                ? (_openBlock(), _createBlock(_component_SharedUpload, {
                    key: 0,
                    class: _normalizeClass(_ctx.b('other-upload')),
                    document: _ctx.file,
                    "is-upload": _ctx.file.isUpload,
                    "is-readonly": _ctx.isReadonly,
                    "is-loading": _ctx.isLoading,
                    isCenter: true,
                    "is-label": false,
                    onUpload: _ctx.handleUploadAdditionalFile
                  }, null, 8, ["class", "document", "is-upload", "is-readonly", "is-loading", "onUpload"]))
                : _createCommentVNode("", true)
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_UIButton, {
        class: _normalizeClass(_ctx.b('verification')),
        label: _ctx.displayedVerificationLabel,
        view: "main",
        disabled: _ctx.isVerificationDisabled,
        onClick: _ctx.handleVerification
      }, null, 8, ["class", "label", "disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["class"]))
}